import React from 'react';
import './Cat.css';

function Header() {
    return (
        <div className="header_main">
            <h1>CAT</h1>
        </div>
    )
}

export default Header;